import { LitElement, html, css } from 'lit';
import { property, query, customElement } from 'lit/decorators.js';

@customElement('langhout-checkbox')
export class LanghoutCheckbox extends LitElement {
  static styles = css`
    :host {
      height: 29px;
    }

    .container {
      display: block;
      position: relative;
      padding-left: 35px;
      margin-bottom: 12px;
      cursor: pointer;
      font-size: 22px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    /* Hide the browser's default checkbox */
    .container input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 25px;
      width: 25px;
      background-color: var(--background-color);
      border: 2px solid var(--text-color-main);
      border-radius: 4px;
    }

    .normal-text {
      text-align: left;
    }

    .bottom-text {
      margin-top: 10px;
    }

    /* On mouse-over, add a grey background color */
    .container:hover input ~ .checkmark {
      background-color: var(--background-color);
    }

    /* When the checkbox is checked, add a blue background */
    .container input:checked ~ .checkmark {
      background-color: var(--primary-color);
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
      content: '';
      position: absolute;
      display: none;
    }

    /* Show the checkmark when checked */
    .container input:checked ~ .checkmark:after {
      display: block;
    }

    /* Style the checkmark/indicator */
    .container .checkmark:after {
      left: 9px;
      top: 5px;
      width: 5px;
      height: 10px;
      border: solid var(--background-color);
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }

    :host([reverse]) .checkmark {
      border: 2px solid var(--text-color-light);
    }
  `;

  @property({ type: Boolean, reflect: true })
  public checked = false;

  @property({ type: Boolean, reflect: true })
  public reverse = false;

  @query('#checkbox')
  public checkBoxElement?: HTMLInputElement;

  constructor() {
    super();
  }

  render() {
    if (this.checked) {
      return html`
        <label class="container">
          <input checked id="checkbox" type="checkbox" />
          <span
            class="checkmark"
            @click="${() => {
              this.checked = !this.checked;
            }}"
          ></span>
        </label>
      `;
    }
    return html`
      <label class="container">
        <input id="checkbox" type="checkbox" />
        <span
          class="checkmark"
          @click="${() => {
            this.checked = !this.checked;
          }}"
        ></span>
      </label>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'langhout-checkbox': LanghoutCheckbox;
  }
}
